import React from "react";
import {Toggle} from "@rescui/toggle";
import {useSetting} from "../../contexts/setting";

/**
 * The Typograf on/off control. Typograf auto-formats the banner text on blur:
 * smart quotes, em dashes, non-breaking spaces and ellipsis.
 *
 * The caller decides where the control goes and whether it shows at all — the
 * Layout panel holds it when that panel is on screen, and the toolbar shows it
 * on its own when the panel is hidden.
 */
export default function TypografToggle() {
  const {isTypografEnabled, editIsTypografEnabled} = useSetting();

  return (
    <div
      className="localization"
      data-tooltip="Auto-formats text: smart quotes, em dashes, non-breaking spaces, ellipsis"
    >
      <span className="label">Typograf</span>
      <Toggle
        checked={isTypografEnabled}
        className="font-toggle"
        onChange={(e) => {
          editIsTypografEnabled(e.target.checked);
        }}
      />
    </div>
  );
}
